import { gql } from '@apollo/client'

export const contactQuery = gql`
  query ContactQuery($id: ID!) {
    contact(id: $id) {
      id
      cpUserId
      contactName
    }
  }
`

export const currentUserQuery = gql`
  query Query {
    currentUser {
      id
      profile {
        name
        contactName
        displayName
        personId
        givenName
        familyName
        gender
        email
        birthDate
        helperPin
        cpUserId
        country
        phoneNumber
        mailingAddress
        preferredLanguage
      }
    }
  }
`

export const helpeeUserQuery = gql`
  query Query {
    currentUser {
      proxyUser {
        id
        contactName
        personId
        cpUserId
      }
    }
  }
`

export const effectiveUserQuery = gql`
  query Query {
    currentUser {
      id
      profile {
        name
        contactName
        displayName
        personId
        givenName
        familyName
        gender
        email
        birthDate
        helperPin
        cpUserId
        country
        phoneNumber
        mailingAddress
        preferredLanguage
      }
      proxyUser {
        id
        contactName
        personId
        cpUserId
      }
    }
  }
`
